"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Ads;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Ads(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "ads"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M84.819,57.036H82.191a2.681,2.681,0,0,1,0-5.362h6.493a2.5,2.5,0,0,0,0-5H82.191a7.681,7.681,0,0,0,0,15.362h2.628a2.681,2.681,0,1,1,0,5.361h-16.9c4.053-3.941,6.422-9.992,6.422-17.4,0-13.4-7.726-22.4-19.224-22.4H44.649a2.5,2.5,0,0,0-2.5,2.5V50.284a2.5,2.5,0,0,0,5,0V32.6h7.966C65.6,32.6,69.339,41.589,69.339,50S65.6,67.4,55.115,67.4H46.059L29.5,29.11a2.5,2.5,0,0,0-4.589,0L7.706,68.905a2.5,2.5,0,1,0,4.588,1.985l5.331-12.327H29.647a2.5,2.5,0,1,0,0-5h-9.86L27.208,36.4,42.122,70.89a2.494,2.494,0,0,0,2.424,1.5c.035,0,.068.01.1.01H55.115c.289,0,.564-.03.848-.041a2.584,2.584,0,0,0,.416.041h28.44a7.681,7.681,0,1,0,0-15.361Z"
  }))));
}